var map = {
	"./branding.png": "../../navigart-conf/img/branding/branding.png",
	"./frachn-accueil.gif": "../../navigart-conf/img/branding/frachn-accueil.gif",
	"./logo-frac-normandie.png": "../../navigart-conf/img/branding/logo-frac-normandie.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./img/branding sync recursive ^\\.\\/.*$";